module.exports = __webpack_public_path__ + "static/media/image-upload.1d357b3f.svg";